// extracted by mini-css-extract-plugin
module.exports = {"root":"table-row-header-cell_root__s4q9m"};